<template>
	<router-form
		@submit="submit"
	></router-form>
</template>

<script>
import * as routerModule from '@/store/router/app.js'
import RouterForm from '@/components/router/RouterForm.vue'
import RouterFormValidation from '@/mixins/router-form-validation.js'

export default {
	async beforeRouteLeave (to, from, next) {
		const hasValues = await this.$store.dispatch('router/hasValues')

		if (hasValues) {
			this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
				modalDesc: 'All your inputs will be gone!',
				action: () => {
					this.$store.commit('router/clearCreateData')
					next()
				}
			})

			return
		}

		this.$store.commit('router/clearCreateData')
		next()
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', routerModule.default)
		}
	},

	async created () {
		await this.$store.dispatch('router/getClientList', '')

	},

	components: {
		RouterForm
	},

	mixins: [
		RouterFormValidation
	]
}
</script>
